var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKvShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9833_5623)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9833_5623",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9833_5623)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9833_5623",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9833_5623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint0_linear_9833_5623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint1_radial_9833_5623)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9833_5623",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9833_5623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint2_linear_9833_5623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint3_radial_9833_5623)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3635 11H8.63623V13H9.3635V11Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99978 10.0181L10.2725 11.5453H7.72705L8.99978 10.0181Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3635 5H8.63623V7H9.3635V5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99978 7.98186L7.72705 6.45459H10.2725L8.99978 7.98186Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.63647H5V9.36374H7V8.63647Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98186 8.99979L6.45459 10.2725V7.72705L7.98186 8.99979Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.63647H11V9.36374H13V8.63647Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0181 8.99979L11.5453 7.72705V10.2725L10.0181 8.99979Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 9.54549C9.30129 9.54549 9.54549 9.30126 9.54549 9.00002C9.54549 8.69879 9.30129 8.45459 9.00002 8.45459C8.69879 8.45459 8.45459 8.69879 8.45459 9.00002C8.45459 9.30126 8.69879 9.54549 9.00002 9.54549Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9833_5623",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BF5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9833_5623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9833_5623",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665DFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E274D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9833_5623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9833_5623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKvShort);
export default __webpack_public_path__ + "static/media/KV-Short.fc865500c3643f82b99c7d5258832ead.svg";
export { ForwardRef as ReactComponent };